'use strict';
const searchHelpers = require('./searchImportedHelperFunctions');
const customSearchHelpers = require('./searchHelperFunctions');
const UPDATEALL = 'updateAll';
const FILTERSUPDATE = 'filtersUpdate';
const MARGINCLASS3 = 'ml-3 mr-3 mb-3';
const btnCloseModalFilter = $(document).find('.ml-4.close.close-section-filter-mobile');

/**
 * @description isMobile function validate which device is being used.
 * @param {boolean} device - if is true the device in mobile
 */
function isMobile() {
    const device = window.matchMedia('(max-device-width: 991px)').matches;
    return device ? true : false;
}

/**
 * @description ShouldApplyfilter function validate if the DOM should be update or just the filter list.
 * @param {String}  filtersUpdate or - updateAll
 */
function ShouldApplyfilter ($this) {
    const btnApplyBtn = $this.data('flag-apply-filters-btn') ? true : false;
    if (!isMobile() || btnApplyBtn) {
        return UPDATEALL;
    }
    return FILTERSUPDATE;
}

/**
 * @description cloneBtnFilters function to clone some element in other.
 * @param {container, element} parameters element to be cloned and container where that element will be added.
 */
function cloneBtnFilters(element, container) {
    $(container).empty();
    const countItems = $('.filter-bar').find('li.filter-value').length;
    if ($('.filter-bar').find('li.filter-value').length > 0) {
        $('.filter-bar').find('li.filter-value').clone().appendTo(container);
        $(container).addClass(MARGINCLASS3);
    } else {
        $(container).removeClass(MARGINCLASS3);
    }
}

$(document).on('search:mobile', function (event, data) {
    if (data.actionToDo === UPDATEALL) {
        customSearchHelpers.updateSearchUrl($(data.$this).attr('data-href'));
        searchHelpers.parseResults(data.response);
        customSearchHelpers.createPaginationUrl();
        cloneBtnFilters('.filter-bar','.btn-filters-cloned');
        if ($('#notProducts').data('dont-have-products')) {
            $('.refinement-bar, .modal-background').hide();
        }
        btnCloseModalFilter.attr('data-href', $(data.$this).attr('data-href'));
        btnCloseModalFilter.attr('data-flag-apply-filters-btn',true);
        $('.refinement-bar, .modal-background').hide();
        $('body').removeClass('modal-open');
    } else {
        searchHelpers.parseResultsMobile(data.response);
        cloneBtnFilters('.filter-bar','.btn-filters-cloned');
        btnCloseModalFilter.attr('data-href', window.location.href);
        btnCloseModalFilter.attr('data-flag-apply-filters-btn',false);
    }
});

$(document).on('search:afterUpdateDom', function (event, $this) {
    if (isMobile()) {
        $('[data-reset-button]').addClass('d-none');
        $('button.apply-filters-just-mobile').attr('data-href',$($this).attr('data-href'));
    }
});

$(document).on('click', '.reset-mobile', function() {
    if (ShouldApplyfilter($(this)) === UPDATEALL) {
        $('button.reset').trigger('click');
    }
});

module.exports = {
    isMobile : isMobile,
    ShouldApplyfilter : ShouldApplyfilter,
    cloneBtnFilters : cloneBtnFilters
}